module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--wave",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c8a49d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Wave.vue
// module id = 947
// module chunks = 170